import { render, staticRenderFns } from "./RelaxSection.vue?vue&type=template&id=3a1220a2&"
import script from "./RelaxSection.vue?vue&type=script&lang=js&"
export * from "./RelaxSection.vue?vue&type=script&lang=js&"
import style0 from "./RelaxSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports